/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import {
  getPeriod,
  restatePeriod,
  setPeriod,
  BILLING_PERIOD,
} from "../billingPeriod.";

type ReturnValues = {
  billingPeriod: string;
  activateCurrentBillingPeriod: () => void;
  activatePreviousBillingPeriod: () => void;
  isCurrentBillingPeriod: boolean;
  isPreviousBillingPeriod: boolean;
};

const reload = () => {
  restatePeriod();
  window.location.reload();
};

export function useBillingPeriod(): ReturnValues {
  const [billingPeriod, setBillingPeriod] = React.useState(
    BILLING_PERIOD.current
  );
  const period = getPeriod()?.period || "";

  React.useEffect(() => {
    restatePeriod();
    setBillingPeriod(period as BILLING_PERIOD);
  }, [setBillingPeriod, period]);

  const activateCurrentBillingPeriod = () => {
    setPeriod(BILLING_PERIOD.current);
    reload();
  };

  const activatePreviousBillingPeriod = () => {
    setPeriod(BILLING_PERIOD.previous);
    reload();
  };

  const isCurrentBillingPeriod = billingPeriod === BILLING_PERIOD.current;

  const isPreviousBillingPeriod = billingPeriod === BILLING_PERIOD.previous;

  return {
    billingPeriod,
    activateCurrentBillingPeriod,
    activatePreviousBillingPeriod,
    isCurrentBillingPeriod,
    isPreviousBillingPeriod,
  };
}
